const toHex = (c: number) => c.toString(16).padStart(2, '0')

// Convert RGBA to solid HEX by blending with a white background
export const rgbaToSolidHex = (r: number, g: number, b: number, a: number, bgR = 255, bgG = 255, bgB = 255) => {
  // Blend each channel: result = alpha * foreground + (1 - alpha) * background
  const blendedR = Math.round(a * r + (1 - a) * bgR)
  const blendedG = Math.round(a * g + (1 - a) * bgG)
  const blendedB = Math.round(a * b + (1 - a) * bgB)

  return `#${toHex(blendedR)}${toHex(blendedG)}${toHex(blendedB)}`.toUpperCase()
}

/// Extract RGBA values from string and convert to solid HEX
export const rgbaStringToSolidHex = (rgba: string) => {
  const match = rgba.match(/rgba?\((\d+),\s*(\d+),\s*(\d+),?\s*([\d.]+)?\)/)
  if (!match) return null

  const [, r, g, b, a = 1] = match
  return rgbaToSolidHex(+r, +g, +b, +a)
}
